import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * ENEQTO brand logo (light-ink variant, for the dark navy sidebar).
 *
 * Rendered as inline SVG so the wordmark can be hidden and the infinity mark
 * animated via CSS — an <img> (the cap-sidebar-menu `logoUrl`) cannot do either.
 * Project into the `[brand]` slot of <cap-sidebar-menu>.
 *
 * - `expanded` drives both the viewBox (full lockup vs mark-only crop) and the
 *   `is-expanded` class. Toggling expanded false→true re-adds the class, which
 *   restarts the CSS draw animation — so the mark re-draws on every expand.
 */
@Component({
  selector: 'app-eneqto-logo',
  templateUrl: './eneqto-logo.component.html',
  styleUrl: './eneqto-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EneqtoLogoComponent {
  /** Whether the sidebar is expanded (wordmark visible) or collapsed (mark only). */
  readonly expanded = input(false);

  /** Full lockup when expanded; cropped to the infinity mark when collapsed. */
  protected readonly viewBox = computed(() => (this.expanded() ? '0 0 900 260' : '180 15 320 230'));
}
